// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__3PGsk","btns":"button-panel_btns__3ZJb2"};